export const commentThread = {
  stats: [
    { id: 'c-1', label: '今夜评论', value: '3,842' },
    { id: 'c-2', label: '正在围观', value: '1,206' },
    { id: 'c-3', label: '已出结果', value: '96' },
  ],
  comments: [
    {
      id: 'cm-01',
      author: '凌晨三点起夜',
      initial: '凌',
      role: '常驻',
      time: '12 分钟前',
      content: '这条线终于有结果了，之前刷了十几个帖子越看越乱，还是按时间排一次最省事。',
      likes: 486,
      replies: 32,
    },
    {
      id: 'cm-02',
      author: '不吃瓜只吃面',
      initial: '面',
      role: '路人',
      time: '26 分钟前',
      content: '第二份说明的日期对不上这件事，才是真正值得记下来的节点，其他都是情绪。',
      likes: 371,
      replies: 58,
    },
    {
      id: 'cm-03',
      author: '避雷小本本',
      initial: '避',
      role: '整理者',
      time: '41 分钟前',
      content: '建议把"已澄清"和"冷处理"分开看，很多人就是把这两类混在一起才越传越离谱。',
      likes: 512,
      replies: 24,
    },
    {
      id: 'cm-04',
      author: '夜班便利店',
      initial: '夜',
      role: '常驻',
      time: '1 小时前',
      content: '翻车合集那张通告单我核对过，时间线是对的，这条可以放心当避雷用。',
      likes: 208,
      replies: 11,
    },
    {
      id: 'cm-05',
      author: '只信原文',
      initial: '原',
      role: '路人',
      time: '2 小时前',
      content: '希望以后每条都标一句"最终结果"，有结果的线看着真的轻松很多。',
      likes: 634,
      replies: 47,
    },
    {
      id: 'cm-06',
      author: '半夜不睡协会',
      initial: '半',
      role: '常驻',
      time: '3 小时前',
      content: '代言那条处理速度比本人快太多，品牌方半夜删联动是真的高效。',
      likes: 179,
      replies: 9,
    },
  ],
};